<template>
  <div class="modal fade" :id="'email-xml-modal-'+modalId" role="dialog" aria-labelledby="emailXmlLabel"
       aria-hidden="true">
    <div class="modal-dialog automation-email-modal-dialog automation-pdf-modal modal-lg" role="emailXmlLabel">
      <div class="modal-content">
        <div class="modal-header" style="cursor: move">
          XML Export
        </div>
        <div class="modal-body">
          <div class="row">

            <div class="col-6">
              <label> Export template </label>
              <select class="form-control" v-model="selected_template">
                <option value="">Select template</option>
                <option v-for="template in templates" v-bind:value="template.id" :key="template.id"> {{ template.name }}</option>
              </select>
            </div>

            <div class="col-6">
              <label> Export filter {{text}}</label>
              <select class="form-control" v-model="selected_filter">
                <option value="">Select filter</option>
                <option v-for="filter in filters" v-bind:value="filter.id"  :key="filter.id"> {{ filter.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer test-modal-footer">
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="AddFilterForAction">
            Add
          </button>
          <button type="button" class="btn btn-default wf-modal-cancel" @click="XMLModalClose">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'table',
    'modalId'
  ],
  data() {
    return {
      filters : [],
      templates : [],
      selected_template : '',
      selected_filter: '',
      text : '',
    }
  },
  mounted() {
    let id = this.table;
    if(id){
      $.ajax({
        type : 'GET',
        url : '/settings/xml_builder/modal_data',
        data : {
          table_id : id,
          type: 'json',
        },
        success : (res) => {
          this.filters = res.xml_filters;
          this.templates = res.xml_templates;
        }
      })
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {
    XMLModalClose() {
      $('#email-xml-modal-' + this.modalId).modal('hide');
    },

    AddFilterForAction(){
      let filter = this.filters.find( obj => obj['id'] === this.selected_filter),
          template = this.templates.find( obj => obj['id'] === this.selected_template);
      if(!template){
        toastr.error('Please select template');
        return;
      }
      this.$emit('addXMLFilterEvent', {
        'filter' : filter ? {
          id : filter.id,
          name : filter.name
        } : '',
        'template' : template ? {
          id: template.id,
          name : template.name
        } : '',
      });
      $('#email-xml-modal-' + this.modalId).modal('hide');
    }
  }
}
</script>